import { FormSection, Timeline } from '@ksyos/design-system';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

export function TpoV1RequestFollowingSteps() {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection title="Vervolgstappen longfunctieonderzoek (aanvragen)">
            <Timeline>
                <Timeline.Item>De desbetreffende zorgverlener kan de spirogram afnemen in de praktijk</Timeline.Item>
                <Timeline.Item>Je doet zelf de beoordeling in het Ksyos platform</Timeline.Item>
                <Timeline.Item>
                    Optioneel: Je stuurt het onderzoek door naar een Ksyos longarts voor diagnose en advies (via een
                    consult)
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
